<div [formGroup]="form" *ngIf="form">
    <div class="row">
        <div class="col-lg-6">
            <mat-form-field class="mat-form-field-fluid">
                <span (click)="assessmentDatePicker.open()">
                    <input matInput [matDatepicker]="assessmentDatePicker" readonly
                        placeholder="Date of assessment"
                        formControlName="assessment_date">
                </span>
                <mat-datepicker-toggle matSuffix [for]="assessmentDatePicker"></mat-datepicker-toggle>
                <button mat-button
                        *ngIf="form.controls.assessment_date.value"
                        matSuffix mat-icon-button matTooltip="Clear"
                        (click)="clearDate(form.controls.assessment_date)">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-datepicker #assessmentDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <mat-table class="mt-4" [dataSource]="components">
        <ng-container matColumnDef="component">
            <mat-header-cell *matHeaderCellDef>Components</mat-header-cell>
            <mat-cell *matCellDef="let item">{{item.label}}</mat-cell>
            <mat-footer-cell *matFooterCellDef>Capital Value</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
            <mat-cell *matCellDef="let item">
                <mat-form-field class="mat-form-field-fluid">
                    <span matPrefix *ngIf="currency">{{currency}}&nbsp;</span>
                    <input matInput placeholder="Value" [formControlName]="item.key"
                        mask="separator.2" thousandSeparator="," />
                </mat-form-field>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                {{currency}} {{capitalValue | number:'1.2-2'}}
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
    </mat-table>

    <mat-form-field class="mat-form-field-fluid mt-4">
        <textarea matInput rows="3" placeholder="Comment" formControlName="rating_comment"></textarea>
    </mat-form-field>
</div>
